import React, { ReactNode, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Alert, Button } from '@intech/web-ui';

import config from "./../../config.json";
import { ArquivoUploadBox, ArquivoUploadTitle } from './styles';
import { FaUpload } from 'react-icons/fa';
import { LoadingComponent } from '@components';

interface IProps {
  ListaArquivo: ArquivoUploadItem[];
  setListaArquivo: (parametros: ArquivoUploadItem[]) => void; // eslint-disable-line no-unused-vars
  titulo?: string;
  texto?: ReactNode;
  passo?: string;
  disabled?: boolean;
  controller: string;
}

export interface ArquivoUploadItem {
  Passo: string;
  TXT_NOME_FISICO: string;
  Arquivo: File;
}

export interface ArquivoUploadBoxProps {
  type: "danger" | "warning" | "info" | "success"
}

export const ArquivoUpload: React.FC<IProps> = ({
  ListaArquivo,
  setListaArquivo,
  controller,
  titulo = "Atenção!",
  texto = "Em caso de alteração de alguma informação será necessário enviar uma cópia de um documento com foto e com o CPF.",
  passo = "",
  disabled = false
}) => {
  const ref = useRef(null);
  const isMountedRef = useRef(true);

  let fileUpload: HTMLInputElement;

  const apiUrl = config.apiUrl;

  const [Loading, setLoading] = useState<boolean>(false);
  const [ListaLocal, setListaLocal] = useState<ArquivoUploadItem[]>([]);
  const [NomeArquivo, setNomeArquivo] = useState<string>("");
  const [AlertText, setAlertText] = useState<string>("");
  const [PassoAtual, setPassoAtual] = useState<string>("");

  useEffect(() => () => { isMountedRef.current = false }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (!isMountedRef.current)
          return;

        setListaLocal(ListaArquivo);
        setPassoAtual(passo);
      }
      catch (err) {
        setAlertText(err["response"] ? err["response"]["data"] : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [passo]);

  async function uploadFile() {
    setLoading(true);
    try {
      setAlertText("");

      const file = fileUpload.files[0];

      const formData = new FormData()
      const arquivoUpload = file;

      formData.append("file", arquivoUpload, `${PassoAtual}, ${arquivoUpload.name}`)

      const app = `@${config.appName}:token`;
      const token = localStorage.getItem(app);

      // const arquivoOid = "";
      const arquivoOid: string = (await axios({
        method: 'post',
        url: `${apiUrl}/${controller}/Upload`,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        },
        data: formData
      })).data;

      if (arquivoOid !== "") {
        const NovoItem: ArquivoUploadItem = {
          Arquivo: arquivoUpload,
          Passo: PassoAtual,
          // Passo: arquivoOid.split("_")[0],
          TXT_NOME_FISICO: arquivoOid
        };

        setListaArquivo([...ListaArquivo, NovoItem]);

        setListaLocal([...ListaLocal, NovoItem]);
      }

      setNomeArquivo("");
    }
    catch (err) {
      const e = err["response"] ? err["response"]["data"] : err;
      console.error(e);
      setAlertText(e);
    }
    setLoading(false);
  }

  function arquivosEnviados() {
    const ListaArquivoPlano = ListaLocal.filter(arquivo => arquivo.Passo === PassoAtual);
    if (ListaArquivoPlano.length > 0) {
      const nomes = ListaArquivoPlano.map((arquivo: ArquivoUploadItem, index: number) => {
        return (
          <li key={index} className={"list-group-item"}>
            {arquivo.Arquivo.name}
            <Button
              title={"Cancelar envio"}
              className={"m-1"}
              size={"mini"}
              type={"danger"}
              onClick={() => cancelarEnvio(arquivo)}
            />
          </li>
        );
      });
      return (
        <ul className={"list-group text-primary"} ref={ref}>{"Arquivos carregados nesse Passo:"}{nomes}</ul>
      );
    }
    return null;
  }

  async function cancelarEnvio(arquivo: ArquivoUploadItem) {
    const l = ListaArquivo.filter(item => item !== arquivo);
    const listaLocal = ListaLocal.filter(item => item !== arquivo);
    setListaArquivo(l);
    setListaLocal(listaLocal);
  }

  function clickarInputFile() {
    const input = document.getElementById("selecionar-documento" + PassoAtual);
    input.click();
  }

  return (
    <ArquivoUploadBox>

      <ArquivoUploadTitle>
        {titulo}
      </ArquivoUploadTitle>

      {texto}

      <br />

      <Button
        title={"ANEXAR DOCUMENTOS"}
        className={"m-1"}
        size={"normal"}
        type={"primary"}
        icon={<FaUpload />}
        onClick={clickarInputFile}
        disabled={disabled}
      />

      {Loading && <LoadingComponent />}

      <input
        style={{ "opacity": "0" }}
        name={"selecionar-documento"}
        id={"selecionar-documento" + PassoAtual}
        type={"file"}
        onChange={uploadFile}
        value={NomeArquivo}
        ref={(ref) => fileUpload = ref}
        accept={"application/msword, image/jpeg, image/bmp, application/pdf, .png, application/vnd.openxmlformats-officedocument.wordprocessingml.document"}
      />

      <br />

      {arquivosEnviados()}

      <br />

      <Alert type={"danger"}>
        {AlertText}
      </Alert>
    </ArquivoUploadBox>
  );
}